import { Template } from '../../../domain/templates/types';

export type RawTemplate = Template & Record<string, unknown>;

export function mapTemplate(raw: RawTemplate): Template {
  return { ...raw, rejectedReason: readRejectedReason(raw) };
}

function readRejectedReason(raw: RawTemplate): string | null {
  const reason = raw['rejectedReason'] ?? raw['rejected_reason'];

  if (typeof reason !== 'string') {
    return null;
  }

  const normalized = reason.trim().toUpperCase();

  return normalized && normalized !== 'NONE' ? normalized : null;
}
